module.exports = __webpack_public_path__ + "static/img/6221_phase_function_Paper_Points.284b5bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6221_phase_function_Paper_Points.png
// module id = LbHr
// module chunks = 0